// Katalogová čísla odpadů v UI (vyhl. č. 8/2021 Sb., datový standard 1.06_t): server je drží bez mezer
// (6 nebo 8 číslic), člověk je píše a čte po dvojicích — `13 02 05`, osmimístný podruh `19 12 04 01`.
// Hledání v registrech přijme kód s mezerami i bez (tečky a pomlčky se ignorují, stejně jako na serveru
// normalizujKod v backend/src/db/import/katalog-odpadu.ts).

/** Kód bez mezer, teček, pomlček a lomítek: „13 02 05“ → „130205“. */
export function normalizovatKodOdpadu(text: string): string {
  return text.replace(/[\s.\-_/]/g, '');
}

/** Kód po dvojicích: „130205“ → „13 02 05“; neznámý tvar vrátí beze změny. */
export function formatKodOdpadu(kod: string | undefined | null): string {
  if (!kod) return '';
  const cisty = normalizovatKodOdpadu(kod);
  return /^\d+$/.test(cisty) ? cisty.replace(/(\d{2})(?=\d)/g, '$1 ') : kod;
}

/** Vypadá hledaný text jako (začátek) katalogového čísla — jen číslice a oddělovače? */
export function jeHledaniKodu(text: string): boolean {
  const cisty = text.trim();
  return cisty !== '' && /^[\d\s.\-_/]+$/.test(cisty) && /\d/.test(cisty);
}

/** Popisek kategorie odpadu. */
export function popisKategorie(kategorie: string | undefined): string {
  if (kategorie === 'N') return 'nebezpečný';
  if (kategorie === 'O') return 'ostatní';
  return kategorie ?? '';
}

/**
 * Skupiny Katalogu odpadů (první dvojčíslí kódu, příloha č. 1 vyhlášky 8/2021 Sb.) ve zkrácené podobě pro nadpisy
 * seznamu v našeptávači položky (úplné znění má backend `SKUPINY_KATALOGU`).
 */
export const SKUPINY_ODPADU: Readonly<Record<string, string>> = {
  '01': 'Těžba a zpracování nerostů a kamene',
  '02': 'Zemědělství, potraviny, lesnictví',
  '03': 'Dřevo, papír a lepenka',
  '04': 'Kůže, kožešiny a textil',
  '05': 'Ropa, zemní plyn a uhlí',
  '06': 'Anorganické chemické procesy',
  '07': 'Organické chemické procesy',
  '08': 'Nátěrové hmoty, lepidla, barvy',
  '09': 'Fotografický průmysl',
  '10': 'Tepelné procesy',
  '11': 'Chemické povrchové úpravy kovů',
  '12': 'Tváření a úprava povrchu kovů a plastů',
  '13': 'Oleje a kapalná paliva',
  '14': 'Rozpouštědla, chladiva a hnací média',
  '15': 'Odpadní obaly, sorbenty, čisticí tkaniny a filtry',
  '16': 'Odpady jinde neuvedené',
  '17': 'Stavební a demoliční odpady',
  '18': 'Zdravotní a veterinární péče',
  '19': 'Zpracování odpadů a čistírny odpadních vod',
  '20': 'Komunální odpady',
};

/** Nadpis skupiny odpadu pro kód: „15 — Odpadní obaly, sorbenty, čisticí tkaniny a filtry“; neznámá skupina jen číslo. */
export function nadpisSkupinyOdpadu(kod: string | undefined | null): string {
  const skupina = normalizovatKodOdpadu(kod ?? '').slice(0, 2);
  if (!/^\d{2}$/.test(skupina)) return 'Ostatní';
  const nazev = SKUPINY_ODPADU[skupina];
  return nazev ? `${skupina} — ${nazev}` : skupina;
}
